import * as React from "react";
import { SVGProps, memo } from "react";
const SvgSpacesMediumExternalServerCertified = (
  props: SVGProps<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="spaces-medium-external-server-certified_svg__Layer_1"
    x={0}
    y={0}
    width={24}
    height={24}
    xmlSpace="preserve"
    role="img"
    {...props}
  >
    <style>
      {".spaces-medium-external-server-certified_svg__st0{fill:#676767}"}
    </style>
    <path
      id="spaces-medium-external-server-certified_svg__Line3_3_"
      className="spaces-medium-external-server-certified_svg__st0"
      d="M16 15h2v1h-2z"
    />
    <path
      id="spaces-medium-external-server-certified_svg__Line2_3_"
      className="spaces-medium-external-server-certified_svg__st0"
      d="M16 10h2v1h-2z"
    />
    <path
      id="spaces-medium-external-server-certified_svg__Line1_3_"
      className="spaces-medium-external-server-certified_svg__st0"
      d="M18 5h-2v1h2z"
    />
    <path
      id="spaces-medium-external-server-certified_svg__ServerOutline_2_"
      className="spaces-medium-external-server-certified_svg__st0"
      d="M20 4c0-.6-.4-1-1-1H4c-.6 0-1 .4-1 1v4c0 .2.1.4.2.5-.1.1-.2.3-.2.5v4c0 .2.1.4.2.5-.1.1-.2.3-.2.5v4c0 .6.4 1 1 1h15c.6 0 1-.4 1-1v-4c0-.2-.1-.4-.2-.5.1-.1.2-.3.2-.5V9c0-.2-.1-.4-.2-.5.1-.1.2-.3.2-.5V4zM4 4h15v4H4V4zm15 9H4V9h15v4zm0 5H4v-4h15v4z"
    />
    <circle
      id="spaces-medium-external-server-certified_svg__CircleBlue_26_"
      cx={18.5}
      cy={17.5}
      r={3.5}
      style={{
        fill: "#4bbc91",
      }}
    />
    <path
      id="spaces-medium-external-server-certified_svg__Check_5_"
      d="M20.5 16c-.2-.1-.4-.1-.6.1L18.4 18l-1.1-.8c-.2-.1-.4-.1-.5 0-.1.2-.1.5 0 .6l1.2.9c.5.4.6.3.9-.1l1.7-2.2c0-.1 0-.2-.1-.4z"
      style={{
        fill: "#fff",
      }}
    />
  </svg>
);
const Memo = memo(SvgSpacesMediumExternalServerCertified);
export default Memo;
